import { render } from "./aio-login-templates.vue?vue&type=template&id=fd961db2&scoped=true"
import script from "./aio-login-templates.vue?vue&type=script&lang=js"
export * from "./aio-login-templates.vue?vue&type=script&lang=js"

import "./aio-login-templates.vue?vue&type=style&index=0&id=fd961db2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd961db2"]])

export default __exports__